import RepaymentReport from "../../../jsx/components/Dashboard/RepaymentReport/RepaymentReport";

const RepaymentReportsWrapper = () => {
  return <RepaymentReport />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.collections,
];
export default constore(RepaymentReportsWrapper);
